<template>
  <div class="pager">
    <div class="addbox">
      <el-button class="add-btn" icon="el-icon-plus" @click="addBanner"
        >添加轮播图</el-button
      >
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <p>跳转类型：</p>
          <el-select
            v-model="queryParams.jumpType"
            placeholder="请选择跳转类型"
          >
            <el-option
              v-for="item in getDictDatas(DICT_TYPE.JUMP_TYPE)"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <p>跳转位置：</p>
          <el-input
            v-model="queryParams.position"
            placeholder="请输入跳转位置"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-popconfirm
            icon="el-icon-info"
            icon-color="red"
            title="确认删除选中的轮播图吗？"
            popper-class="customerdel-popover"
            @confirm="deleteFn()"
          >
            <el-button
              slot="reference"
              icon="el-icon-delete"
              class="add-btn"
              style="margin-right: 10px"
              >删除</el-button
            >
          </el-popconfirm>
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        show-overflow-tooltip
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="img" label="轮播图封面">
          <template slot-scope="{ row }">
            <div class="logo">
              <img :src="row.img" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="jumpType_dictText"
          label="跳转类型"
        ></el-table-column>
        <el-table-column
          prop="position_dictText"
          label="跳转位置"
        ></el-table-column>
        <el-table-column prop="parameter" label="跳转参数" min-width="120">
          <template slot-scope="{ row }">
            {{ row.parameter ? row.parameter : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="发布时间" min-width="120">
        </el-table-column>
        <el-table-column prop="status_dictText" label="状态">
          <template slot-scope="{ row }">
            <el-button :class="row.status === 0 ? 'success-btn' : 'fail-btn'">{{
              row.status_dictText
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-popconfirm
              title="是否启用该banner图？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row, 0)"
              v-if="Number(scope.row.status) === 1"
            >
              <el-button class="textOrange-btn" slot="reference"
                >启用</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否禁用该banner图"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row, 1)"
              v-if="Number(scope.row.status) === 0"
            >
              <el-button class="textOrange-btn" slot="reference"
                >禁用</el-button
              >
            </el-popconfirm>
            <el-button class="textOrange-btn" @click="goEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
  </div>
</template>

<script>
import { getBannerList, editBannerStatus, deleteBanner } from "@/api/home";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        jumpType: "",
        position: "",
      },
      tableData: [],
      total: 0, //总数
      selectList: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取用户列表
    async init() {
      const res = await getBannerList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.jumpType = "";
      this.queryParams.position = "";
      this.queryParams.pageNum = 1;
      this.init();
    },
    // 去添加
    addBanner() {
      this.$router.push({
        path: "/addpaper",
        query: {
          type: "add",
        },
      });
    },
    // 去修改
    goEdit(item) {
      localStorage.setItem("bannerInfo", JSON.stringify(item));
      this.$router.push({
        path: "/addpaper",
        query: {
          type: "edit",
        },
      });
    },
    //修改banner 状态
    async cancelOrder(item, status) {
      const params = {
        status,
        id: item.id,
      };
      await editBannerStatus(params);
      // this.$refs[`${text}-popover-${index}`].doClose();
      this.init();
    },
    // 选择
    handleSelectionChange(val) {
      this.selectList = val.map((el) => {
        return el.id;
      });
    },
    // 删除
    async deleteFn() {
      if (this.selectList.length === 0) {
        this.$message.error("请先选择要删除的轮播图");
        return;
      }
      await deleteBanner(this.selectList);
      this.$message.success("删除成功");
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.pager {
  position: relative;
  .addbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }
        .el-input,
        .el-range-editor {
          width: 216px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox {
      display: flex;
      align-items: center;
    }
  }
  .content {
    .logo {
      display: flex;
      justify-content: center;
      order-radius: 10px;
      img {
        width: 100%;
        border-radius: 4px;
      }
    }
    .textOrange-btn {
      margin: 0 10px;
    }
    ::v-deep .is-checked {
      .el-checkbox__inner {
        background-color: #ff5d2f;
        border-color: #ff5d2f;
      }
    }
    ::v-deep .is-indeterminate {
      .el-checkbox__inner {
        background-color: #ff5d2f;
        border-color: #ff5d2f;
      }
    }

    ::v-deep .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
